"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractKeyFromPackageJson = exports.extractKey = void 0;
const read_file_1 = require("./read-file");
const artifact_description_error_1 = require("./artifact-description-error");
const extract_from_pom_xml_1 = require("./extract-from-pom-xml");
const extract_from_package_json_1 = require("./extract-from-package-json");
/**
 * Reads an ArtifactKey object from the given directory.
 *
 * The return value will be non-null if an artifact key (group ID, artifact ID) is specified in either the package.json
 * file or the pom.xml file, in the given directory. If both files specify an artifact key, this function will check
 * that the two keys are identical (throwing an exception if not). If neither file specifies an artifact key, the return
 * value will be null.
 *
 * This function can also fail with an exception if the artifact key (in either file) does not pass basic validations,
 * such as: length limit, legal characters, etc.
 *
 * @param dir directory to read the data from
 */
function extractKey(dir) {
    var _a;
    const packageJson = (0, read_file_1.readFile)(dir, 'package.json');
    const packageJsonKey = packageJson.isPresent ? (_a = (0, extract_from_package_json_1.extractFromPackageJson)(packageJson)) === null || _a === void 0 ? void 0 : _a.key : null;
    const pomXmlArtifact = (0, extract_from_pom_xml_1.extractFromPomXml)(dir);
    if (!packageJsonKey) {
        return pomXmlArtifact ? pomXmlArtifact.key : null;
    }
    if (!pomXmlArtifact) {
        return packageJsonKey;
    }
    if (packageJsonKey.groupId !== pomXmlArtifact.key.groupId) {
        throw new artifact_description_error_1.ArtifactDescriptionError(`groupId: value mismatch between package.json and pom.xml in ${dir}`);
    }
    if (packageJsonKey.artifactId !== pomXmlArtifact.key.artifactId) {
        throw new artifact_description_error_1.ArtifactDescriptionError(`artifactId: value mismatch between package.json and pom.xml in ${dir})`);
    }
    return pomXmlArtifact.key;
}
exports.extractKey = extractKey;
function extractKeyFromPackageJson(dir) {
    var _a;
    const packageJson = (0, read_file_1.readFile)(dir, 'package.json');
    if (!packageJson.isPresent) {
        throw new artifact_description_error_1.ArtifactDescriptionError(`No package.json in ${dir}`);
    }
    const packageJsonArtifact = (0, extract_from_package_json_1.extractFromPackageJson)(packageJson);
    return (_a = packageJsonArtifact.key) !== null && _a !== void 0 ? _a : null;
}
exports.extractKeyFromPackageJson = extractKeyFromPackageJson;
//# sourceMappingURL=extract-key.js.map